export default class DistributorsService {

  constructor(Restangular, $state, SessionsService) {
    'ngInject';
    this.Restangular = Restangular;
    this.$state = $state;
    this.SessionsService = SessionsService;
    this.MANAGING_ORG_SERVICE = 'distributors';
  }

  save(tenant) {
    if (tenant.key !== undefined) {
      var promise = tenant.put();
    } else {
      var promise = this.Restangular.service(this.MANAGING_ORG_SERVICE).post(tenant);
    }
    return promise;
  }

  fetchAll() {
    let promise = this.Restangular.all(this.MANAGING_ORG_SERVICE).getList();
    return promise;
  }

  fetchAllByUser(userKey) {
    if (userKey) {
      let promise = this.Restangular.one('users', userKey).doGET('managing_orgs');
      return promise;
    }
  }

  getById(key) {
    let promise = this.Restangular.oneUrl(this.MANAGING_ORG_SERVICE, `${process.env.__backendUrl__}/internal/v1/managing_orgs/${key}`).get();
    return promise;
  }

  delete(entity) {
    if (entity.key) {
      let promise = this.Restangular.one(this.MANAGING_ORG_SERVICE, entity.key).remove();
      return promise;
    }
  }

  getByName(name) {
    let promise = this.Restangular.all(this.MANAGING_ORG_SERVICE).getList({distributorName: name});
    return promise;
  }

  getDomainsById(key) {
    let promise = this.Restangular.oneUrl(this.MANAGING_ORG_SERVICE, `${process.env.__backendUrl__}/internal/v1/managing_orgs/${key}/domains`).get();
    return promise;
  }

  switchDistributor(distributor) {
    this.SessionsService.setCurrentDistributorName(distributor.name);
    this.SessionsService.setCurrentDistributorKey(distributor.id);
    this.SessionsService.setCurrentDistributorCode(distributor.code);
    return this.$state.go('main.welcome');
  }
}
